import React, { useEffect } from 'react';
import PageHeading from '../../Components/PageHeading/PageHeading';
import './AboutUs.css';
import Banner from '../Home/Banner/Banner'
import MetaData from '../../Components/MetaData/MetaData';
import about1 from './Image/about1.png';
import about2 from './Image/about2.png';
import about3 from './Image/about3.png';
import about4 from './Image/about4.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


const AboutUs = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div>
      <MetaData
        pageTitle={
          "Best Generative AI Tool for Beginners | Easy Generative AI"
        }
        pageDescription={
          "Find the best generative AI tools for beginners to create text, images, audio, and more. Enjoy user-friendly platforms designed for easy learning and creativity."
        }
        canonical="https://whalesai.com/about-us"
      ></MetaData>
      <div className=''>
        <PageHeading title={'ABOUT US'} />
        <div className="container account-container pb-5 about-us px-4">
          <Swiper
            slidesPerView={1}
            loop={false}
            centeredSlides={true}
            autoplay={false}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className="about-us-swiper"
          >
            <SwiperSlide>
              <img src={about1} alt="About 1" className="about-image" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={about2} alt="About 2" className="about-image" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={about3} alt="About 3" className="about-image" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={about4} alt="About 4" className="about-image" />
            </SwiperSlide>
          </Swiper>
        </div>

      </div>
      <Banner />
    </div>
  );
};

export default AboutUs;
